import { Typography } from '@mui/material'

export function NotFound() {
  return <Typography>404 Not Found</Typography>
}
